const PERMISSION_KEY= "core:user_cash_plan";
const PAGE_URL = {
    USER_CASH_PLAN_PAGE: "/admin/core/user-cash-plan"
}

export {PERMISSION_KEY, PAGE_URL}

